"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Explanation_1 = __importDefault(require("../Explanation"));
const common_1 = require("./common");
function MecanismRésoudreRéférenceCirculaire({ explanation }) {
    return (jsx_runtime_1.jsxs(common_1.Mecanism, Object.assign({ name: "r\u00E9soudre la r\u00E9f\u00E9rence circulaire", value: explanation.valeur }, { children: [jsx_runtime_1.jsxs("p", { children: [' ', "Cette valeur a \u00E9t\u00E9 retrouv\u00E9 en r\u00E9solvant la r\u00E9f\u00E9rence circulaire dans la formule ci dessous :", ' '] }, void 0), jsx_runtime_1.jsx(Explanation_1.default, { node: explanation.valeur }, void 0)] }), void 0));
}
exports.default = MecanismRésoudreRéférenceCirculaire;
